export default __webpack_public_path__ + "static/soko2017-5bb967a5024dbbaa1e6dda86b86c6593.png";